export function toNumber(value?: string | number | null): number | null {
	const result = parseInt(String(value).replace(/[^0-9]/gi, ''), 10);
	return isNaN(result) ? null : result;
}
